import { SacPurposeDialogComponent } from './../../../common/sac-purpose/components/sac-purpose-dialog/sac-purpose-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FORM_TEXTS } from './../../objects/placeholders';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CampaignService, EventsService, SignupService, StorageService, UtilService, VariablesService } from '../../../shared/services';
import { StartAFrUrls } from 'src/app/shared/models/start-fr-urls';

declare global {
  interface Window { VWO: any; }
}

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {

  info;
  param: string;
  draft;
  draftId;
  type;
  entityId;
  causes;
  draftChecked: boolean;
  startAFrUrls = StartAFrUrls;

  constructor(
    private actRoute: ActivatedRoute,
    private campaignService: CampaignService,
    private util: UtilService,
    private vars: VariablesService,
    private router: Router,
    private events: EventsService,
    private signupService: SignupService,
    private dialog: MatDialog
  ) {
    if (!this.actRoute.snapshot.queryParams.saf_source) {
      this.router.navigate([], { queryParams: { saf_source: this.vars.pageName }, queryParamsHandling: 'merge' });
    }
  }

  ngOnInit() {
    this.activateVWOTest();
    if (typeof document !== 'undefined') {
      document.body.classList.add('bg-gray');
    }
    this.getParam();
    this.setLanguage();
  }

  /** Get the URL Activated URL */
  getActivatedURl() {
    if (typeof window !== 'undefined' && window.location) {
      this.util.siteUrl.next(window.location.origin);
    }
  }
  /**
   * Get URL params
   */
  getParam() {
    this.actRoute.params.subscribe(param => {
      this.param = param['id'];
      this.util.param.next(this.param);
    });
    const entity_type = this.actRoute.snapshot.queryParams['entity_type'];
    const entity_id = this.actRoute.snapshot.queryParams['entity_id'];
    if (entity_type && entity_id) {
      const path = this.startAFrUrls['non-medical'];
      this.router.navigate([path], { queryParams: { type: 'ngo' }, queryParamsHandling: 'merge' });
      return false;
    }
    this.getEntityId();
    this.getDraftId();
    this.getActivatedURl();
    this.sendSystemEventOnLoad();
    this.vars.pageName = 'medical-sac';
  }

  async checkForDraft() {
    if (this.draftChecked) {
      return true;
    }
    const isDraftExist = await this.signupService.checkForDraft(false);
    const type = this.actRoute.snapshot.queryParams['type'];
    if (!isDraftExist && !this.vars.purposeSelected && !type) {
      const dialogRef = this.dialog.open(SacPurposeDialogComponent, {
        panelClass: 'sac-purpose-changer',
        data: {
          showWarningText: false,
          frType: 'medical'
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          const sacInitiatedPayload = this.util.storage.getFromSession('sac-initiated');
          const sacPuposeSelected = this.util.storage.getFromSession('sac-purpose-selected');
          if (!sacPuposeSelected) {
            const payload = {
              eventName: 'cause_selection',
              page_name: this.vars.pageName,
              info_1: sacInitiatedPayload.info_1 || '',
              info_2: sacInitiatedPayload.info_2 || '',
              info_4: result.data,
              event_type: 'campaign'
            };
            this.events.systemEventPush(payload);
            this.util.storage.addSessionData('sac-purpose-selected', { 'purpose': result.data });
          }
          const path = result.data === 'medical' ?
            this.startAFrUrls.medical :
            this.startAFrUrls['non-medical'];
          this.router.navigate([path], { queryParams: { type: result.data }, queryParamsHandling: 'merge' });
        }
      });
    } else if (isDraftExist && !(/1|8/).test(this.signupService.draftData?.status_flag)) {
      this.signupService.draftRedirection();
    }
  }

  /**
   * Get draft id from URL query params
   */
  getDraftId() {
    this.actRoute.queryParams.subscribe(param => {
      this.draftId = this.actRoute.snapshot.queryParams['did'];
      const type = this.actRoute.snapshot.queryParams['type'];
      this.util.campaignType.next(type);
      if (this.draftId) {
        this.getDraftById(type);
        this.setCampaignData();
        this.checkForDraft();
      } else {
        this.router.navigate(
          [this.startAFrUrls.medical, 'basic'],
          { queryParams: { type: type }, queryParamsHandling: 'merge' }
        );
        this.checkForDraft();
        this.draftChecked = true;
      }
    });
  }
  /**Get Entity id from local storage */
  getEntityId() {
    const data = this.util.getUserData();
    this.entityId = data?.id;
  }
  /**
   * Get draft details
   */
  getDraft() {
    this.vars.draftObs.subscribe((res) => {
      this.draft = res;
    });
  }
  /**
   * Get draft details from API
   */
  getDraftById(type?) {
    this.campaignService.getCampaignDraft(this.draftId).subscribe(
      (res: any) => {
        this.draft = res.data;
        this.vars.draftObs.next(res.data);
        if (res.data.cause.id !== 59) {
          this.router.navigate(
            [this.startAFrUrls['non-medical'], 'basic'],
            { queryParams: { did: res.data.id }, queryParamsHandling: 'merge' }
          );
          return;
        }
        this.getCauses(res.data.parent_cause_id);
        // this.resumeCampaign();
      },
      async (error) => {
        this.router.navigate(
          [this.startAFrUrls.medical, 'basic'],
          { queryParams: { type: type }, queryParamsHandling: 'merge' }
        );
      }
    );
  }
  /**Get the causes */
  getCauses(id) {
    this.campaignService.getCauses(id).subscribe((res: any) => {
      this.causes = this.util.setArray(res.data.child, 'id', 'info_1');
    });
  }
  // System push on load
  sendSystemEventOnLoad() {
    const payload = {
      eventName: 'pageView',
      event_type: '',
      page_name: 'start_new_campaign'
    };
    this.events.onLoadSystemEvent(payload);
  }

  activateVWOTest() {
    this.util.activateVWOTest(this.util.domain_details.full_url);
  }

  setLanguage(data?) {
    const lang = this.util.storage.get('language');
    this.info = lang ? FORM_TEXTS[lang] : FORM_TEXTS['English'];
  }

  /**
   * Called once, before the instance is destroyed.
   * Add 'implements OnDestroy' to the class.
   */
  ngOnDestroy(): void {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('bg-gray');
    }
  }

  setCampaignData(): void {
    this.campaignService.getCampaign(parseInt(this.draftId, 10)).subscribe((res: any) => {
      if (res?.data) {
        this.vars.campaignId = res?.data?.id;
        this.vars.medicalbill = res?.data?.media?.filter(o => o.display_type_1 === 'medicalbill');
      }
    });
  }

}
